import { OrderStorage } from './order.storage';
import { mergeDeep, setOrderData } from '../../../helpers';

export class OrderDeliveryCheckbox extends OrderStorage {
  buttons;

  deliveryInfo = {};

  onChangeDeliveryType() {
    this.buttons = {
      radioButtons: this.order.querySelectorAll('input[name="delivery_method"]'),
      deliveryShopSelf: this.order.querySelector('input[name="delivery_method"][value="1"]'),
      courrierRadio: this.order.querySelector('input[name="delivery_method"][value="2"]'),
      moscowRadio: this.order.querySelector('input[name="delivery_method"][value="3"]'),
      cdekRadio: this.order.querySelector('input[name="delivery_method"][value="4"]'),
    };

    const Type = {
      deliveryShopSelf: 1,
      moscowRadio: 2,
      courrierRadio: 3,
      cdekRadio: 4,
    };

    this.skipStep(4, 5, this.buttons.deliveryShopSelf.checked);

    if (this.buttons.deliveryShopSelf.checked) {
      this.insetToContactsSelfShop();
      document.querySelector('[data-delivery-text]').classList.remove('d-flex');
      document.querySelector('[data-delivery-text]').classList.add('d-none');
    } else {
      document.querySelector('[data-delivery-text]').classList.remove('d-none');
      document.querySelector('[data-delivery-text]').classList.add('d-flex');
    }

    [...this.buttons.radioButtons].forEach((button) => {
      button.addEventListener('change', (e) => {
        const local = this.getJsonStorage();
        const currentType = Number(e.currentTarget.value);

        local.data.delivery_method = button.value;

        const isDeliverySelf = (this.getJsonStorage().data.city === 'Москва'
          && this.getJsonStorage().data.street === 'Загородное шоссе'
          && this.getJsonStorage().data.building === '15, корп.1');

        if (isDeliverySelf) {
          this.order.querySelector('#step-4 form').reset();
        }

        switch (currentType) {
          case Type.deliveryShopSelf:
            this.insetToContactsSelfShop();
            break;
          case Type.moscowRadio:
            this.isCourrierRadioChecked(this.buttons.courrierRadio.checked);
            break;
          case Type.courrierRadio:
            this.isCdekRadioChecked(this.buttons.moscowRadio.checked);
            break;
          case Type.cdekRadio:
            this.isCdekRadioChecked(this.buttons.cdekRadio.checked);
            break;
          default:
            this.order.querySelector('#step-4 form').reset();
        }

        if (Number(local.data.delivery_method) === Type.deliveryShopSelf) {
          this.order.querySelector('#step-4 form').reset();
        }

        if (local.data) this.setStorage(local);

        this.skipStep(4, 5, this.buttons.deliveryShopSelf.checked);
      });
    });

    return this;
  }

  isCourrierRadioChecked(state) {
    if (state) {
      this.DataForm.delete('region');
      this.setDeliveryInfoFromLocal();
      document.querySelector('#city').value = 'Москва';
      document.querySelector('#step-4 form').classList.remove('was-validated');
    }
    return this;
  }

  isCdekRadioChecked(state) {
    if (state) {
      this.DataForm.delete('region');
      this.setDeliveryInfoFromLocal();
      document.querySelector('#step-4 form').classList.remove('was-validated');
    }
    return this;
  }

  insetToContactsSelfShop() {
    const form = this.order.querySelector('#step-4 form');
    form.reset();
    form.city.value = 'Москва';
    form.address.value = 'Загородное шоссе';
    form.house.value = '15, корп.1';
    this.DataForm = form;
  }

  setDeliveryInfoFromLocal() {
    const local = this.getJsonStorage();
    const {
      index,
      region,
      city,
      street,
      building,
      flat,
      flatRoom,
      floor,
      date,
      apartment,
      intercom_code,
    } = local.data;
    const localDeliveryInfo = {
      index,
      region,
      city,
      street,
      building,
      flat,
      flatRoom,
      floor,
      date,
      apartment,
      intercom_code,
    };

    const isDeliverySelf = (city === 'Москва' && street === 'Загородное шоссе' && building === '15, корп.1');

    if (!isDeliverySelf) {
      this.deliveryInfo = mergeDeep(this.deliveryInfo, localDeliveryInfo);
    }

    /* eslint-disable-next-line */
    for (const [key, value] of Object.entries(this.deliveryInfo)) {
      setOrderData(key, value);
    }

    return this;
  }
}
